module.exports = __webpack_public_path__ + "static/footer-2c54609b578efdf1bfec99b328025e3f.png";